import request from '@/utils/request'

const portalApi = process.env.VUE_APP_PORTAL_API

// 获取服务器系统时间
export function getTimeMillisApi() {
  return request({
    url: portalApi + '/common/time-millis',
    method: 'get'
  })
}
